"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const PopupPanel_vue_1 = require("../common/PopupPanel.vue");
const CardName_1 = require("@/common/cards/CardName");
const GameModule_1 = require("@/common/cards/GameModule");
const ClientCardManifest_1 = require("@/client/cards/ClientCardManifest");
const CardType_1 = require("@/common/cards/CardType");
const utils_1 = require("@/common/utils/utils");
function corpCardNames(module) {
    return (0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byModule)(module))
        .filter((0, ClientCardManifest_1.byType)(CardType_1.CardType.CORPORATION))
        .map(utils_1.toName)
        .filter((name) => name !== CardName_1.CardName.BEGINNER_CORPORATION);
}
const interim = GameModule_1.GAME_MODULES.map((module) => [module, []]);
const ALL_CARDS_BY_MODULE = Object.fromEntries(interim);
(0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byType)(CardType_1.CardType.CORPORATION)).forEach((card) => {
    if (card.name !== CardName_1.CardName.BEGINNER_CORPORATION) {
        ALL_CARDS_BY_MODULE[card.module].push(card.name);
    }
});
GameModule_1.GAME_MODULES.forEach((module) => ALL_CARDS_BY_MODULE[module].sort());
exports.default = vue_1.default.extend({
    name: 'CorporationsFilter',
    components: {
        PopupPanel: PopupPanel_vue_1.default,
    },
    props: {
        expansions: Object,
        selected: Object,
    },
    data() {
        return {
            filterText: '',
            selectedCorporations: this.selected.length > 0 ? this.selected : [
                ...corpCardNames('base'),
                ...this.expansions.corpera ? corpCardNames('corpera') : [],
                ...this.expansions.prelude ? corpCardNames('prelude') : [],
                ...this.expansions.prelude2 ? corpCardNames('prelude2') : [],
                ...this.expansions.venus ? corpCardNames('venus') : [],
                ...this.expansions.colonies ? corpCardNames('colonies') : [],
                ...this.expansions.turmoil ? corpCardNames('turmoil') : [],
                ...this.expansions.promo ? corpCardNames('promo') : [],
                ...this.expansions.community ? corpCardNames('community') : [],
                ...this.expansions.moon ? corpCardNames('moon') : [],
                ...this.expansions.pathfinders ? corpCardNames('pathfinders') : [],
                ...this.expansions.underworld ? corpCardNames('underworld') : [],
            ],
        };
    },
    computed: {
        GAME_MODULES() {
            return GameModule_1.GAME_MODULES;
        },
        MODULE_NAMES() {
            return GameModule_1.MODULE_NAMES;
        },
        ALL_CARDS_BY_MODULE() {
            return ALL_CARDS_BY_MODULE;
        },
    },
    methods: {
        getItemsByGroup(group) {
            if (group === 'All')
                return GameModule_1.GAME_MODULES.map((module) => ALL_CARDS_BY_MODULE[module]).flat();
            const corps = ALL_CARDS_BY_MODULE[group];
            if (corps === undefined) {
                console.log('module %s not found', group);
                return [];
            }
            else {
                return corps.slice();
            }
        },
        selectAll(group) {
            const items = this.getItemsByGroup(group);
            for (const item of items) {
                if (this.selectedCorporations.includes(item) === false) {
                    this.selectedCorporations.push(item);
                }
            }
        },
        removeFromSelection(cardName) {
            const itemIdx = this.selectedCorporations.indexOf(cardName);
            if (itemIdx !== -1) {
                this.selectedCorporations.splice(itemIdx, 1);
            }
        },
        selectNone(group) {
            const items = this.getItemsByGroup(group);
            for (const item of items) {
                this.removeFromSelection(item);
            }
        },
        invertSelection(group) {
            const items = this.getItemsByGroup(group);
            for (const idx in items) {
                if (this.selectedCorporations.includes(items[idx])) {
                    this.removeFromSelection(items[idx]);
                }
                else {
                    this.selectedCorporations.push(items[idx]);
                }
            }
        },
        watchSelect(module, enabled) {
            enabled ? this.selectAll(module) : this.selectNone(module);
        },
        compatibility(corporation) {
            return (0, ClientCardManifest_1.getCard)(corporation)?.compatibility ?? [];
        },
        icon(module) {
            let suffix = module;
            if (module === 'colonies')
                suffix = 'colony';
            if (module === 'moon')
                suffix = 'themoon';
            return `create-game-expansion-icon expansion-icon-${suffix}`;
        },
        include(name) {
            const normalized = this.filterText.toLocaleUpperCase();
            if (normalized.length === 0) {
                return true;
            }
            return name.toLocaleUpperCase().includes(normalized);
        },
    },
    watch: {
        selectedCorporations(value) {
            this.$emit('corporation-list-changed', value);
        },
        corporateEra(enabled) {
            this.watchSelect('corpera', enabled);
        },
        prelude(enabled) {
            this.watchSelect('prelude', enabled);
        },
        venusNext(enabled) {
            this.watchSelect('venus', enabled);
        },
        colonies(enabled) {
            this.watchSelect('colonies', enabled);
        },
        turmoil(enabled) {
            this.watchSelect('turmoil', enabled);
        },
        promoCardsOption(enabled) {
            this.watchSelect('promo', enabled);
        },
        communityCardsOption(enabled) {
            this.watchSelect('community', enabled);
        },
        moonExpansion(enabled) {
            this.watchSelect('moon', enabled);
        },
        pathfindersExpansion(enabled) {
            this.watchSelect('pathfinders', enabled);
        },
    },
});
